<template>
	<aside class="aside-menu">

	</aside>
</template>

<script>
export default {
	name: 'c-aside'
}
</script>



// WEBPACK FOOTER //
// src/components/Aside.vue